import React from "react";

const visaOptions = [
  {
    id: "188",
    label:
      "Business Innovation and Investment (Provisional) visa (subclass 188)",
    type: 1
  },
  {
    id: "189",
    label: "Skilled Independent visa (subclass 189)",
    type: 2
  },
  {
    id: "190",
    label: "Skilled Nominated visa (subclass 190)",
    type: 3
  },
  {
    id: "489",
    label: "Skilled Regional (Provisional) visa (subclass 489)",
    type: 4
  },
  {
    id: "491",
    label:
      "Skilled Work Regional (Provisional) visa (subclass 491)",
    type: 5
  }
];

function VisaSubclassStep({ value, onChange, onNext }) {
  return (
    <section className="visa-card">
      <h2>Select visa subclass</h2>

      {visaOptions.map((visa) => (
        <label key={visa.id} className="visa-radio">
          <input
            type="radio"
            name="visa"
            checked={value === visa.type}
            onChange={() => onChange(visa.type)}
          />
          <span className="visa-radio__label">
            {visa.label}
          </span>
        </label>
      ))}

      <div className="form-actions">
        <button
          type="button"
          className="btn-next"
          disabled={!value}
          onClick={onNext}
        >
          Next
        </button>
      </div>
    </section>
  );
}

export default VisaSubclassStep;
